import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment'
import {CommonService} from '../common-code/common.service'

@Injectable({
  providedIn: 'root'
})


export class DatasourceService {

  constructor( private CS: CommonService) { 

  }

  public getDataSourceList(input:any){
    var url=environment.baseurl + 'Broker/GetBrokersByUser';
    return this.CS.Post(url,input);
  }
  public updateversion(input_data: any)
  {
    //console.log(input_data);
    var url=environment.baseurl + 'Broker/UpdateBrokerVersion';
    return this.CS.Post(url, input_data);
  }
  public addUpdateDatasource(input_data: any)
  {
    //console.log(input_data);
    var url=environment.baseurl + 'Broker/Saveorupdatebroker';
    return this.CS.Post(url, input_data);
  }
  public dologin(input_data: any)
  {
    //console.log(input_data);
    var url=environment.baseurl + 'user/userlogin';
    return this.CS.Post(url, input_data);
  }
  public GetAllUserDtails()
  {
    //console.log(input_data);
    var url=environment.baseurl + 'user/GetAllUserDtails?token='+environment.MasterToken;
    return this.CS.Get(url);
  }
  public UpdateStateAction(input_data: any)
  {
    //console.log(input_data);
    var url=environment.baseurl + 'user/UpdateStateAction';
    return this.CS.Post(url, input_data);
  }
  ValidationAlert(data,value)
  {
    if(data==""||data==null)
    {
      alert('Please add a '+value+'.');
      return false;
    }
    else
    return true;
  }

}
